import { ReactElement, useCallback } from "react"
import { useDropzone } from "react-dropzone"

import { Icon } from "@wfp/ui"
import { iconUpload } from "@wfp/icons"

type Props = {
  files: File[]
  onChange: (files: File[] | null) => void
  placeholder?: string
}

const FileUploader = ({ files, onChange, placeholder }: Props): ReactElement => {
  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      onChange(acceptedFiles)
    },
    [onChange],
  )

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx", ".xls"],
    },
    multiple: false,
  })

  const wrapperClassNames = `wfp--dropzone__input ${isDragActive ? "wfp--dropzone__input--drag-active" : ""}`

  return (
    <section className="wfp--dropzone">
      <div {...getRootProps({ className: wrapperClassNames })}>
        <input {...getInputProps()} />
        <Icon className="wfp--dropzone__icon" icon={iconUpload} description="Upload" />
        {files?.length ? (
          <div className="text-center">{files?.map(file => file.name)}</div>
        ) : (
          <div>{placeholder || "Drag & Drop your Excel file here or click to upload Excel file"}</div>
        )}
      </div>
    </section>
  )
}

export default FileUploader
